'use strict'
import React from 'react'
import { makeStyles, Box, Typography, Paper } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2)
  },
  card: {
    flex: '1 1 140px',
    padding: theme.spacing(1.5),
    textAlign: 'center',
    minWidth: 120
  },
  value: {
    fontSize: '1.5rem',
    fontWeight: 700
  },
  label: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    marginTop: 2
  },
  routeInfo: {
    marginBottom: theme.spacing(2)
  }
}))

export default function CutCrewImpactSummary ({ cutRoute, displaced, suggestedMovesCount, unassignedCount, warnings }) {
  const classes = useStyles()

  const cards = [
    { label: 'Displaced', value: displaced?.propertyCount || 0 },
    { label: 'Reassigned', value: suggestedMovesCount || 0, color: '#4caf50' },
    { label: 'Unassigned', value: unassignedCount || 0, color: unassignedCount > 0 ? '#f44336' : undefined },
    { label: 'VIP Affected', value: displaced?.vipCount || 0, color: displaced?.vipCount > 0 ? '#ff9800' : undefined },
    { label: 'Locked (cut crew)', value: displaced?.lockedToCutCrewCount || 0 },
    { label: 'Weekly Minutes', value: displaced?.weeklyServiceMinutes || 0 }
  ]

  return (
    <Box>
      <Box className={classes.routeInfo}>
        <Typography variant="subtitle1">
          <strong>Cutting:</strong> {cutRoute?.routeName || 'Unknown'} — {cutRoute?.crewName || 'Unknown'}
        </Typography>
      </Box>
      {warnings && warnings.length > 0 && warnings.map((w, i) => (
        <Typography key={i} variant="body2" style={{ color: '#f44336', marginBottom: 8 }}>{w}</Typography>
      ))}
      <div className={classes.root}>
        {cards.map(card => (
          <Paper key={card.label} className={classes.card} variant="outlined">
            <Typography className={classes.value} style={card.color ? { color: card.color } : undefined}>
              {card.value}
            </Typography>
            <Typography className={classes.label}>{card.label}</Typography>
          </Paper>
        ))}
      </div>
    </Box>
  )
}
